// extracted by mini-css-extract-plugin
export default {"container":"f1-z"};